import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, NavLink } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { put } from '../../utils/api';
import { Form, FormInput } from '../common/Form';
import { genPassword } from '../../utils/genPassword';
//
// Компонент для редактирования пользователя
//
const UserEdit = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
    const user = useSelector(state => state.user);
	const [ name, setName ] = useState(user ? user.name : '');
	const [ email, setEmail ] = useState(user ? user.email : '');
    const [ password, setPassword ] = useState('');
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');
        setSuccess('');

        const result = await put('/users/' + user._id, { name, email, password });

        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess('useredit.success');
			navigate('/cabinet/userview/' + result.data.user._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{t('useredit.title_' + user.role)}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
            <React.Fragment>
			<Form
                success={success}
                error={saveError}
                info={'useredit.subtitle'}
                submit={t('useredit.submit')}
				onSubmit={onSubmit}
            >
				<FormInput
					id='name'
                    type='text'
					value={name}
					onChange={setName}
                    placeholder={t('useredit.name_' + user.role)}
                    label={t('useredit.name_' + user.role)}
                    required={true}
				/>
				<FormInput
					id='email'
                    type='text'
					value={email}
					onChange={setEmail}
                    placeholder={t('useredit.email')}
                    label={t('useredit.email')}
                    required={true}
				/>
                <FormInput
                    id='password'
                    type='text'
                    value={password}
                    onChange={setPassword}
                    placeholder={t('useredit.password')}
                    label={t('useredit.password')}
                    top={t('useredit.password_hint')}
                />
                <strong
					onClick={() => setPassword(genPassword(10))}
					style={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        color: 'var(--main-color)',
                        textAlign: 'right',
                    }}
				>
					{t('useredit.password_generate')} <Icon icon={faRotate}/>
				</strong>
			</Form>
            <NavLink to={'/cabinet/userview/' + user._id}>
                {t('useredit.back')}
            </NavLink>    
            </React.Fragment>}
        </div>
	);
};

export default UserEdit;
